<template>
    <div class="card">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <form class="row" v-on:submit.prevent="submit">
                <div class="col-md-3">
                    <div class="form-group">
                        <label>نام</label>
                        <input type="text" class="form-control" v-model="name">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>نام خانوادگی</label>
                        <input type="text" class="form-control" v-model="lastName">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>کد ملی</label>
                        <input type="tel" class="form-control ltr-input" v-model="nationalNo" maxlength="10">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>شماره همراه</label>
                        <input type="tel" class="form-control ltr-input" v-model="phone" maxlength="11">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>ایمیل</label>
                        <input type="email" class="form-control ltr-input" v-model="email">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>تاریخ تولد</label>
                        <Datepicker simple auto-submit locale="fa" v-model="birthDate" :max="maxDate" :locale-config="{
                            fa: {
                                displayFormat: 'jYYYY/jMM/jDD',
                                lang: {label: 'شمسی'}
                            }
                        }" />
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>نقش</label>
                        <Vselect v-model="roleId" :reduce="item => item.value" label="title" :options="roles">
                            <div slot="no-options">مقداری یافت نشد</div>
                        </Vselect>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>دامنه</label>
                        <Vselect v-model="domainId" :reduce="item => item.value" label="title" :options="domains">
                            <div slot="no-options">مقداری یافت نشد</div>
                        </Vselect>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>دامنه داده ای</label>
                        <Vselect v-model="domainDataId" :reduce="item => item.value" label="title" :options="domainData">
                            <div slot="no-options">مقداری یافت نشد</div>
                        </Vselect>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>رمز عبور</label>
                        <input type="password" class="form-control ltr-input" v-model="password">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>تکرار رمز عبور</label>
                        <input type="password" class="form-control ltr-input" v-model="confirmPassword">
                    </div>
                </div>
                <div class="col-md-12 my-3" style="display: flex; justify-content: end;">
                    <button class="btn btn-primary" style="width: 300px;">ایجاد کاربر</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import moment from 'moment-jalaali';
export default {
    name: 'Create',
    data(){
        return {
            showLoading: false,
            name: '',
            lastName: '',
            phone: '',
            password: '',
            confirmPassword: '',
            nationalNo: '',
            birthDate: '',
            email: '',
            roleId: '',
            domainId: '',
            domainDataId: '',
            domains: [],
            domainData: [],
            roles: [],
            maxDate: moment().format('jYYYY/jM/jD')
        }
    },
    methods: {
        getData(){
            this.$api.post('User/GetRole',{}).then(({data}) => {
                if(data.status){
                    let roles = [];
                    data.result.map(item => {
                        roles.push({
                            title: item.persianTitle,
                            value: item.roleId
                        });
                    })
                    this.roles = roles;
                }
            });
            this.$api.post('User/GetDomain',{}).then(({data}) => {
                if(data.status){
                    let domains = [];
                    data.result.map(item => {
                        domains.push({
                            title: item.title,
                            value: item.domainId
                        });
                    })
                    this.domains = domains;
                }
            });
            this.$api.post('User/GetDomainData',{domainId:61}).then(({data}) => {
                if(data.status){
                    let domainData = [];
                    data.result.map(item => {
                        domainData.push({
                            title: item.fullName || '-',
                            value: item.domainDataId
                        });
                    })
                    this.domainData = domainData;
                }
            });
        },
        submit(){
            if(this.password != this.confirmPassword){
                this.$swal({
                    title: 'خطا',
                    icon: 'error',
                    text: 'رمز عبور و تکرار رمز عبور یکسان نیستند',
                    confirmButtonText: 'متوجه شدم'
                });
                return false;
            }
            this.showLoading = true;
            const postedData = {
                name: this.name,
                lastName: this.lastName,
                phone: this.phone,
                password: this.password,
                confirmPassword: this.confirmPassword,
                nationalNo: this.nationalNo,
                birthDate: this.birthDate,
                roleId: this.roleId,
                domainId: this.domainId,
                parentId: this.domainDataId,
                email: this.email
            };
            this.$api.post('User/CreateUser',postedData).then(({data}) => {
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'کاربر جدید با موفقیت ایجاد شد'
                    }).then(() => {
                        this.$router.push({name: 'users'});
                    });
                }
            }).finally(() => {
                this.showLoading = false;
            });
        }
    },
    created(){
        this.getData();
    }
}
</script>